import i18n from "i18next";
import { z } from "zod";
import { notificationSchema } from "../utils";

const LANG_BASE = "vessel-call.port-services.fields";

const actualNumberOfSkipsSchema = z.object({
  actualNumberOfSkips: z.preprocess(
    (value) => {
      if (value === "" || value === null || value === undefined) return undefined;
      return Number(value);
    },
    z
      .number({
        required_error: i18n.t("form-validation.required", {
          label: i18n.t(`${LANG_BASE}.actual-number-of-skips`),
        }),
        invalid_type_error: i18n.t("form-validation.required", {
          label: i18n.t(`${LANG_BASE}.actual-number-of-skips`),
        }),
      })
      .min(
        0,
        i18n.t("form-validation.required", {
          label: i18n.t(`${LANG_BASE}.actual-number-of-skips`),
        }),
      )
      .optional(),
  ),
});

export const approveByOperationsGarbageDisposalSchema = () =>
  actualNumberOfSkipsSchema.merge(notificationSchema);

export type ApproveByOperationsGarbageDisposalSchema = z.infer<
  ReturnType<typeof approveByOperationsGarbageDisposalSchema>
>;
